import { render, staticRenderFns } from "./RatingConfigShow.vue?vue&type=template&id=16c85257&"
import script from "./RatingConfigShow.vue?vue&type=script&lang=js&"
export * from "./RatingConfigShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports